import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { OrderFile } from 'contracts/OrderFiles';

const { Types, Creators } = createActions(
  {
    request: ['id', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'FETCH_ORDER_FILE_',
  }
);

export interface FetchOrderFileState {
  data: OrderFile | null;
  loading: boolean;
  errorMessage: string | null;
}

export interface FetchOrderFileRequestAction {
  id: number;
  onSuccess?: (data?: any) => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: OrderFile;
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: FetchOrderFileState = {
  data: null,
  loading: false,
  errorMessage: null,
};

const request = (state: FetchOrderFileState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: FetchOrderFileState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: FetchOrderFileState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: FetchOrderFileState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const fetchOrderFile = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const FetchOrderFileTypes = Types;
export const FetchOrderFileActions = Creators;
